import axios from 'axios'

const Api = {
    login: (params) => {
        return axios.post('login/', { ...params })
            .then((res) => res.data)
    },
    fetchDashboard: () => {
        return axios.get('dashboard/')
            .then((res) => {
                return res.data
            })
    },
    fetchLicenses: (params) => {
        return axios.get('licenses/', {params})
            .then((res) => {
                return res.data
            })
    },
    searchServices: (params) => {
        if (params.searchPhrase.trim().length < 3) {
            return Promise.resolve({ results: [], count: 0 });
        }

        return axios.get('search/', { params })
            .then((res) => {
                return { results: res.data, count: res.data.length };
            })
    },
    searchByLogID: (params) => {
        if (params.searchPhrase.trim().length < 3) {
            return Promise.resolve({ results: [], count: 0 });
        }

        return axios.get('search_service_ip/', { params })
            .then((res) => {
                return { results: res.data, count: res.data.length };
            })
    },
    fetchProblematicServices: (params) => {
        const results = axios.get('problematic_services/')
            .then((res) => {
                return { results: res.data, count: res.data.length };
            })
        return results;
    },
    fetchRegions: () => {
        return axios.get('regions/').then((res) => { return res.data })
    },
    fetchSSOLink: () => {
        return axios.get('/login').then((res) => { return res.data })
    },
    logout: () => {
        return axios.get('logout/')
            .then((res) => res.data)
    },
    getLoginLink: (account_id) => {
        return axios.get('get_login_url/', { params: { account_id } })
            .then((res) => res.data)
    },
    generateToken: (account_id) => {
        return axios.get('get_login_url/', { params: { account_id, generate_new_key: true } })
            .then((res) => res.data)
    },
    extendTrial: (data) => {
        return axios.patch('extend_license/', { data })
            .then((res) => res.data)
    },
    removeRestrictions: (account_id) => {
        return axios.get('remove_restrictions/', { params: { account_id } })
            .then((res) => res.data)
    },
    getLicenses: (account_id) => {
        return axios.get('get_licenses/', { params: { account_id } })
            .then((res) => res.data)
    },
    getWaasServiceOptions: (id) => {
        return axios.get('get_waas_service_options/', { params: { id } })
            .then((res) => res.data)
    },
    set_waas_service_options: (id, data) => {
        return axios.patch('set_waas_service_options/', { id, session_timeout: data.session_timeout })
            .then((res) => res.data)
    },
    set_secondary_app: (params) => {
        return axios.patch('set_secondary_app/', params )
            .then((res) => res)
    },
    showServicesLocations: (id) => {
        return axios.get('show_services_locations/', { params: { id } })
            .then((res) => res.data)
    },
    fetchMixedHealthServers: (id) => {
        return axios.get('stats/', { params: { id } })
            .then((res) => res.data)
    },
    fetchServerTree: (id) => {
        return axios.get('tree', { params: { id } })
            .then((res) => res.data)
    },
    fetchGlobalDcStats: (params) => {
        return axios.get('global_dc_stats', { params })
            .then((res) => res.data)
    },
    getExpiredAccounts: (params) => {
        return axios.get('expired_accounts', { params })
            .then((res) => res.data)
    },
    getRlc: (region, lb, container) => {
        const rlc = [region, lb, container]
        return axios.get('waas_container_devices', {params: {rlc: rlc}}).then(res => res.data)
    },
    getSupportTunnel: (params) => {
        return axios.get('open_support_tunnel_container_device', {params}).then(res => res.data)
    },
    getPing: (params) => {
        return axios.get('ping_container_device', {params}).then(res => res.data)
    },
    fetchClusters: () => {
        return axios.get('clusters/').then((res) => { return res.data })
    },
    fetchContainersProblematicServices: () => {
        const results = axios.get('containers_problematic_services/')
            .then((res) => {
                return { results: res.data, count: res.data.length };
            })
        return results;
    },
    getServerHealth: (server_id) => {
        return axios.get('get_server_health/', { params: { server_id } })
            .then((res) => res.data)
    },
    getDevicesInfo: (region_id) => {
        return axios.get('get_devices_info/', { params: { region_id } })
            .then((res) => res.data)
    },
    getTrafficManagersInfo: () => {
        return axios.get('get_traffic_managers_info/')
            .then((res) => res.data)
    },
    getCustomerContainerInfo: (customer_container_id) => {
        return axios.get('customer_container_devices/', { params: { customer_container_id: customer_container_id } })
            .then((res) => res.data)
    },
}

export default Api;